/**
 * CommentTextCount
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';

class CommentTextCount {

	private selector: string;

	private textareaSelector: string;

	private countWordSelector: string;

	private max: number;

	constructor( selector: string ) {
		this.selector = selector;
		this.textareaSelector = `${selector} textarea`;
		this.countWordSelector = `${selector} .count-word em`;
		this.max = Config.commentTextMaxCount;
		this.addEvent();
	}

	public reset() {
		const _$countWord = jQuery( this.countWordSelector );
		_$countWord.text( '0' );
	}

	public setCountByText( text: string ) {
		const _len = Util.StringLength( text, 1, 1 );
		const _$countWord = jQuery( this.countWordSelector );
		_$countWord.text( _len );
	}

	private addEvent() {
		jQuery( 'body' ).on( 'keyup', this.textareaSelector, ( evt ) => {
			this.count();
		});
	}

	private count() {
		const _text: any = jQuery( this.textareaSelector );
		const _$countWord = jQuery( this.countWordSelector );
		let _val = _text.val();
		let _len = Util.StringLength( _val, 1, 1 );

		if ( _len >= this.max ) {
			_val = _val.substring( 0, this.max );
			_text.val( _val );
			_len = this.max;
		}
		_$countWord.text( _len );
	}
}

export default CommentTextCount;
